import { MathJax, MathJaxContext } from "better-react-mathjax";
import React from "react";

const renderOption = (optionText) => {
  const latexPattern = /\$(.*?)\$/g;
  const parts = optionText.split(latexPattern);

  return parts.map((part, index) => {
    if (index % 2 === 0) {
      return <span key={index} dangerouslySetInnerHTML={{ __html: part }} />;
    } else {
      return <MathJax.Node key={index} formula={part} />;
    }
  });
};

const LatexTextRendererMcq = ({ text }) => {
  const { finaloption1, option1_img, finaloption2, option2_img, finaloption3, option3_img, finaloption4, option4_img } = text;

  // Calculate max length of all options to determine layout
  const calculateMaxLength = () => {
    const options = [finaloption1, finaloption2, finaloption3, finaloption4].filter(Boolean);

    if (options.length === 0) return 0;

    return Math.max(...options.map(option => {
      // Strip HTML tags for length calculation
      let text = option?.replace(/\u003c[^\u003e]*\u003e/g, '') || '';

      // Remove common HTML entities
      text = text.replace(/&nbsp;/g, ' ')
        .replace(/&lt;/g, '\u003c')

        .replace(/&gt;/g, '\u003e')
        .replace(/&amp;/g, '&')
        .trim();

      return text.length;
    }));
  };

  const maxLength = calculateMaxLength();

  // Updated 3-tier layout system for MCQ options:
  // - Very short options (≤10 chars): 25% width = 4 options per line
  // - Standard options (11-40 chars): 50% width = 2 options per line
  // - Long options (>40 chars): 100% width = 1 option per line
  let optionWidth = "100%"; // default for long options
  if (maxLength <= 10) {
    optionWidth = "25%"; // 4 options in single line
  } else if (maxLength <= 40) {
    optionWidth = "50%"; // 2 options in single line (most common)
  }

  return (
    <MathJaxContext>
      <div className="flex items-center">
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '5px',
          width: '100%'
        }}>
          {(option1_img || finaloption1) &&
            <div style={{
              display: "flex",
              alignItems: "center",
              width: optionWidth,
              boxSizing: "border-box",
              paddingRight: optionWidth !== "100%" ? "10px" : "0",
              whiteSpace: maxLength > 20 ? "normal" : "nowrap",
              overflow: "visible"
            }}>
              <div style={{ marginRight: "5px", flexShrink: 0 }}>A .</div>
              <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>
                {option1_img ?
                  <img
                    src={option1_img}
                    alt="Option A"
                    style={{ maxWidth: "100px", height: "auto", marginRight: "5px", flexShrink: 0 }}
                  /> :
                  renderOption(finaloption1)
                }
              </div>
            </div>}
          {(option2_img || finaloption2) &&
            <div style={{
              display: "flex",
              alignItems: "center",
              width: optionWidth,
              boxSizing: "border-box",
              paddingRight: optionWidth !== "100%" ? "10px" : "0",
              whiteSpace: maxLength > 20 ? "normal" : "nowrap",
              overflow: "visible"
            }}>
              <div style={{ marginRight: "5px", flexShrink: 0 }}>B .</div>
              <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>
                {option2_img ?
                  <img
                    src={option2_img}
                    alt="Option B"
                    style={{ maxWidth: "100px", height: "auto", marginRight: "5px", flexShrink: 0 }}
                  /> :
                  renderOption(finaloption2)
                }
              </div>
            </div>}
          {(option3_img || finaloption3) &&
            <div style={{
              display: "flex",
              alignItems: "center",
              width: optionWidth,
              boxSizing: "border-box",
              paddingRight: optionWidth !== "100%" ? "10px" : "0",
              whiteSpace: maxLength > 20 ? "normal" : "nowrap",
              overflow: "visible"
            }}>
              <div style={{ marginRight: "5px", flexShrink: 0 }}>C .</div>
              <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>
                {option3_img ?
                  <img
                    src={option3_img}
                    alt="Option C"
                    style={{ maxWidth: "100px", height: "auto", marginRight: "5px", flexShrink: 0 }}
                  /> :
                  renderOption(finaloption3)
                }
              </div>
            </div>}
          {(option4_img || finaloption4) &&
            <div style={{
              display: "flex",
              alignItems: "center",
              width: optionWidth,
              boxSizing: "border-box",
              paddingRight: optionWidth !== "100%" ? "10px" : "0",
              whiteSpace: maxLength > 20 ? "normal" : "nowrap",
              overflow: "visible"
            }}>
              <div style={{ marginRight: "5px", flexShrink: 0 }}>D .</div>
              <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>
                {option4_img ?
                  <img
                    src={option4_img}
                    alt="Option D"
                    style={{ maxWidth: "100px", height: "auto", marginRight: "5px", flexShrink: 0 }}
                  /> :
                  renderOption(finaloption4)
                }
              </div>
            </div>}
        </div>
      </div>
    </MathJaxContext>
  );
};

export default LatexTextRendererMcq;